import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

export const useUnlockPartFile: MutationFunction<
  never,
  {
    uuid: string;
    quoteId: number;
    accessCode: string;
  }
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    ({ uuid, quoteId, accessCode }) =>
      request(`/parts/files/${uuid}/unlock`, {
        init: {
          method: 'POST',
          body: { quoteId, accessCode },
        },
        query,
      }),
    queryOptions,
  );
};
